import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/out/order";

export default {
    /** 分页查询出库单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询出库单详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存出库单（草稿） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 提交出库单（扣减库存） */
    submit: (id) => axios.post({url: `${PREFIX_URI}/submit?id=${id}`}),
    /** 删除出库单 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
}
